import french from 'date-fns/locale/fr';
import spanish from 'date-fns/locale/es';
import english from 'date-fns/locale/en-US';
import { enUS, esES, frFR } from '@mui/x-date-pickers/locales';
import {MODEL_LANGUAGE} from "../components/Language/Model/Models";

export const dateInputLanguage = (lCode) => {
    switch (lCode) {
        case MODEL_LANGUAGE.SP.code:
            return spanish;
        case MODEL_LANGUAGE.FR.code:
            return french;
        default:
            return english;
    }
};

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 * Returns the MUI Date Pickers localeText configuration based on the provided language code.
 *
 * @param {string} lang - Language code (e.g., "en", "en-US", "es", "fr").
 * @returns {object} The localeText configuration for MUI LocalizationProvider.
 */

export const muiLocaleText = (lang) => {
    const normalizedLang = lang?.split('-')[0];

    switch (normalizedLang) {
        case MODEL_LANGUAGE.SP.code:
            return esES.components.MuiLocalizationProvider.defaultProps.localeText;
        case MODEL_LANGUAGE.FR.code:
            return frFR.components.MuiLocalizationProvider.defaultProps.localeText;
        case  MODEL_LANGUAGE.EN.code:
        default:
            return enUS.components.MuiLocalizationProvider.defaultProps.localeText;
    }
};

export const dateInputYearDigit = (lang, value) => {

    switch (lang) {
        case MODEL_LANGUAGE.SP.code:
            return 'A'.repeat(value); // AAAA
        case MODEL_LANGUAGE.FR.code:
            return 'A'.repeat(value); // AAAA (année)
        case  MODEL_LANGUAGE.EN.code:
        default:
            return 'Y'.repeat(value); // YYYY
    }
};
